import {
  CheckDeliveryDateSelectableRequest,
  CheckDeliveryDateSelectableResponse,
} from "@delivery-dates/types";
import { BaseAPI } from "@utils/base-api";
import { Dayjs } from "dayjs";
import { DeliveryDateProductType, DeliveryDateOrderType } from "@/primary-models";

export class DeliveryDatesAPI extends BaseAPI {

  public async checkDeliveryDateSelectable(
    deliveryDate: Dayjs, 
    productType?: DeliveryDateProductType, 
    orderType?: DeliveryDateOrderType
  ): Promise<CheckDeliveryDateSelectableResponse> {
    const request: CheckDeliveryDateSelectableRequest = {
      deliveryDate,
      productType,
      orderType,
    };

    const response = await this.axios.post<CheckDeliveryDateSelectableResponse>("check-selectable", request);
    return response.data;
  }

}
